import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from 'recharts';
import { ComplaintDetectionData } from '../../../../types/dashboard-v4.types';
import { PanelHeading } from './PanelHeading';

interface ComplaintDetectionChartProps {
  data: ComplaintDetectionData[];
}

export const ComplaintDetectionChart: React.FC<ComplaintDetectionChartProps> = ({ data }) => {
  // Use the data passed from props (API data)
  // If no data is provided, fall back to empty array
  const stackedData = data?.length ? data : [];

  // Colors from Figma design
  const colors = {
    dissatisfaction: '#500091', // Indigo (dark purple)
    potential: '#904EFD', // Purple (medium purple)
    formal: '#FFA9E7' // Pink (light pink)
  };

  return (
    <div className="bg-white rounded-lg h-[232px]" style={{ padding: '14px 20px 20px 20px' }}>
      <PanelHeading>
        Complaint detection
      </PanelHeading>
      
      <div style={{ height: '130px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart 
            data={stackedData}
            margin={{ top: 5, right: 30, left: 30, bottom: 20 }}
            barCategoryGap="20%"
          >
            <XAxis 
              dataKey="date" 
              axisLine={{ stroke: '#E0E0E0', strokeWidth: 1 }}
              tickLine={false}
              tick={{ fontSize: 5.52, fill: '#262628', fontFamily: 'Open Sans, sans-serif' }}
              height={20}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 5.52, fill: '#262628', fontFamily: 'Open Sans, sans-serif' }}
              domain={[0, 100]}
              ticks={[0, 25, 50, 75, 100]}
            />
            
            <Bar dataKey="dissatisfaction" stackId="stack" fill={colors.dissatisfaction} maxBarSize={40} />
            <Bar dataKey="potential" stackId="stack" fill={colors.potential} maxBarSize={40} />
            <Bar dataKey="formal" stackId="stack" fill={colors.formal} maxBarSize={40} radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      
      <div className="flex items-center gap-[20px] mt-[15px] ml-[12px]">
        <div className="flex items-center gap-[5px]">
          <div className="w-3 h-3 rounded-full" style={{ backgroundColor: colors.dissatisfaction }}></div>
          <span className="text-[6px] font-semibold text-[#262628]" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            No Complaint
          </span>
        </div>
        <div className="flex items-center gap-[5px]">
          <div className="w-3 h-3 rounded-full" style={{ backgroundColor: colors.potential }}></div>
          <span className="text-[6px] font-semibold text-[#262628]" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Potential Complaint
          </span>
        </div>
        <div className="flex items-center gap-[5px]">
          <div className="w-3 h-3 rounded-full" style={{ backgroundColor: colors.formal }}></div>
          <span className="text-[6px] font-semibold text-[#262628]" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Formal Complaint
          </span>
        </div>
      </div>
    </div>
  );
};